module.exports = __webpack_public_path__ + "img/page8.6dfd1cd0.png";